import React from "react";

// Brand logo. Black artwork; pass `light` to render white on dark backgrounds.
const Logo = ({ light = false, className = "" }) => (
  <img
    src="/logo-20proof.png"
    alt="20 PROOF \u2014 The Decade of Becoming"
    className={className}
    style={light ? { filter: "invert(1) brightness(2)" } : undefined}
    draggable={false}
  />
);

export default Logo;
